import { errorModal } from "../components/modals/utils";

function setErrorModal(title, texts, icon, customButtons) {
  errorModal.setInfos(
    title,
    texts,
    {
      label: customButtons ? customButtons[0].label : "Ok",
      onClick: customButtons ? customButtons[0].onClick : errorModal.close,
    },
    customButtons && customButtons[1] ? customButtons[1] : undefined,
    icon
  );
}

function alertError(msg) {
  const texts = typeof msg === "string" ? [msg] : msg;
  setErrorModal("Erro", texts, "error");
}

function alertWarning(msg) {
  const texts = typeof msg === "string" ? [msg] : msg;
  setErrorModal("Aviso", texts, "warning");
}

function alertSuccess(msg) {
  const texts = typeof msg === "string" ? [msg] : msg;
  setErrorModal("Sucesso", texts, "success");
}

const alerts = {
  alertError,
  alertWarning,
  alertSuccess,
  setErrorModal,
};

export default alerts;
